import { useEffect, useRef } from "react";

const FormikDirtyWatcher = ({ step, values, snapshot, defaultInitialValues, onDirty }) => {
    const prev = useRef(undefined);

    useEffect(() => {
        const compareWith = snapshot || defaultInitialValues;
        const isDirty = JSON.stringify(values) !== JSON.stringify(compareWith);

        if (prev.current !== isDirty) {
            onDirty(step, isDirty);
            prev.current = isDirty;
        }
    }, [step, values, snapshot, defaultInitialValues, onDirty]);
    return null;
};
export default FormikDirtyWatcher;